export default __webpack_public_path__ + "static/media/bk1.1abf2ee3.jpg";